import { render } from "./BookMarkGrn.vue?vue&type=template&id=493a58a0&scoped=true"
import script from "./BookMarkGrn.vue?vue&type=script&lang=js"
export * from "./BookMarkGrn.vue?vue&type=script&lang=js"

import "./BookMarkGrn.vue?vue&type=style&index=0&id=493a58a0&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493a58a0"]])

export default __exports__